import React, { createContext, useState } from "react";

export const ServerErrorContext = createContext();

export function ServerErrorProvider({ children }) {
  const [isServerError, setIsServerError] = useState(false);

  return (
    <ServerErrorContext.Provider value={{ isServerError, setIsServerError }}>
      {children}
    </ServerErrorContext.Provider>
  )
}
